module.exports = __webpack_public_path__ + "static/img/agent2.f68577b8.png";